//@dependencies
import { Grid2, Snackbar } from "@mui/material";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import PropTypes from "prop-types";
import React, { useState } from "react";
//styles
import styles from "./IconDetails.module.scss";

export default function IconDetails(props) {
  //props and hooks
  const { icon, title, subTitle, copy } = props;
  //variables
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleCopy = () => {
    if (copy) {
      navigator.clipboard.writeText(subTitle);
      setSnackbarOpen(true);
    }
  };

  let Icon = icon;

  return (
    <>
      <Grid2 className={styles.iconContainer}>
        <Grid2 className={styles.CopyFlexBox}>
          <Grid2 className={styles.TextFlexBox}>
            <Grid2 className={styles.border}>
              <Icon
                className={`${styles.icon} ${
                  title === "PHP Version" ? styles.width : ""
                }`}
              />
            </Grid2>
            <Grid2>
              <Grid2 className={styles.title}>{title}</Grid2>
              <Grid2 className={styles.subTitle}>{subTitle}</Grid2>
            </Grid2>
          </Grid2>
          <Grid2>
            {copy && (
              <>
                <ContentCopyOutlinedIcon
                  onClick={handleCopy}
                  className={styles.copyIcon}
                />
              </>
            )}
          </Grid2>
        </Grid2>
      </Grid2>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={() => setSnackbarOpen(false)}
        message="Link copied to clipboard"
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        // sx={{
        //   "& .MuiSnackbarContent-root": {
        //     backgroundColor: "#333",
        //     color: "#fff",
        //     borderRadius: "8px",
        //     padding: "10px 16px",
        //     boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        //   },
        // }}
      />
    </>
  );
}

// PropTypes
IconDetails.propTypes = {
  icon: PropTypes.any.isRequired, // SvgIconComponent
  iconColor: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  copy: PropTypes.bool,
};
